import { AppStatus } from '@/redux'
import { getFirebase } from '../../firebaseApp'
import { userHasSocialLogin } from './userHasSocialLogin'

export const isEmailVerified = async (data) => {
  const firebase = await getFirebase()
  const firebaseUser = firebase.auth().currentUser
  const { hasSocialLogin } = await userHasSocialLogin()

  if (hasSocialLogin) return true
  if (!firebaseUser || !data) return false
  if (data?.id !== firebaseUser.uid) return false
  return firebaseUser.emailVerified
}

import { Topic } from '../../../utils/hooks/topic' //WTF!

export const emailVerification = Topic.named<boolean>('emailVerification')

export const ensureEmailVerified = async (profile) => {
  const emailVerified = await isEmailVerified(profile)

  if (!emailVerified) {
    AppStatus.setModal('verifyEmailBefore')
    const res = await emailVerification.wait(null)

    if (!res) {
      throw new Error('Email not verified')
    }
  }
}